<template>
    <div class="input-dot">
        <input
            :class="[ inputClass ]"
            :placeholder="placeholder"
            :value="outputValue"
            readonly
            autocomplete="off"
            @click="openModalDot()"
        />

        <div class="icon" :class="{ 'disabled': readonly }">
            <b-icon icon="x" @click="closeOut()"></b-icon>
        </div>

        <div class="modal-mask" v-if="isActive">
            <div class="modal-dot-input">
                <div class="box">
                    <div class="input">
                        <div class="data" v-for="(item, index) in 4" :key="index">
                            <button class="increase" @click="changeNumber(1, index)"><b-icon icon="caret-up-fill"></b-icon></button>
                            <span>{{ dotValue[index] }}</span>
                            <button class="decrease" @click="changeNumber(-1, index)"><b-icon icon="caret-down-fill"></b-icon></button>
                        </div>
                    </div>

                    <div class="text-right operation">
                        <button class="btn btn-blue btn-choose" @click="choose()">เลือก</button>
                        <button class="btn btn-grey btn-choose" @click="hide()">ปิด</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Helper from '@/resources/Helper';

export default {
    data() {
        return {
            isActive: false,
            dotValue: [],
            outputValue: ''
        };
    },
    props: {
        value: {
            required: true
        },
        placeholder: {
            type: String,
            required: false,
            default: () => ''
        },
        inputClass: {
            type: Array,
            required: false,
            default: () => null
        },
        readonly: {
            type: Boolean,
            required: false,
            default: () => false
        }
    },
    watch: {
        isActive(value) {
            this.isActive = value;
            this.$root.$emit('rootSetContentScrollable', !value);
        },
        value(current) {
            this.setupModelValue(current);
        }
    },
    mounted() {
        this.setInitValue();
    },
    methods: {
        hide() {
            this.isActive = false;
        },
        initField() {
            let initValue = '';

            if (this.value) {
                initValue = this.value;
            } else if (localStorage.latestInputDot) {
                initValue = localStorage.latestInputDot;
            } else {
                const weekNumberData = Helper.getWeekNumber(new Date());
                initValue = weekNumberData[1] + '' + weekNumberData[0];
            }
            
            this.dotValue = initValue.split('');
        },
        openModalDot() {
            if (!this.readonly) {
                this.isActive = true;
                this.initField();
            }
        },
        setInitValue() {
            this.setupModelValue(this.value);
        },
        choose() {
            let value = this.dotValue.join('');
            
            this.setupModelValue(value);
            this.hide();
        },
        closeOut() {
            if (!this.readonly) {
                this.setupModelValue('');
            }
        },
        setupModelValue(value) {
            if (value) {
                localStorage.latestInputDot = value;
            }

            this.outputValue = value;

            this.$emit('input', value);
            this.$emit('change', value);
        },
        changeNumber(number, index) {
            let data = parseInt(this.dotValue[index]);

            data += number;
            
            // First Digit
            if (index === 0) {
                if (data < 0) {
                    data = 5;
                }
                if (data > 5) {
                    data = 0;
                }
            }
            
            if (data < 0) {
                data = 9;
            }
            if (data > 9) {
                data = 0;
            }

            this.$set(this.dotValue, index, data);
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/Variable.scss';

.input-dot {
    position: relative;
    
    .input-field {
        cursor: pointer;
    }

    .icon {
        position: absolute;
        z-index: 0;
        right: 10px;
        top: 0;
        bottom: 0;
        height: 100%;
        cursor: pointer;
        display: flex;
        align-items: center;

        &.disabled {
            cursor: default;
        }
    }
}

.modal-dot-input {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;

    .box {
        .input {
            display: flex;
            background: $contentColor;
            padding: 40px 10px;

            .data {
                position: relative;
                margin: 2px;
                
                span {
                    font-size: 32px;
                    font-weight: bold;
                    color: $textMainColor;
                    border: 1px solid $inputBackgroundColor;
                    background: $inputBackgroundColor3;
                    padding: 5px 15px;
                }

                button {
                    position: absolute;
                    display: block;
                    width: 100%;
                    background: none;
                    border: none;
                    color: $textLighterColor;

                    &.increase {
                        top: -30px;
                    }

                    &.decrease {
                        bottom: -30px;
                    }

                    &:hover {
                        opacity: 0.4;
                    }
                }
            }
        }

        .operation {
            display: flex;

            .btn {
                width: 50%;
            }

            .btn + .btn {
                margin-left: 1px;
            }

            .btn-choose {
                padding: 6px 15px;
            }
        }
    }
}
</style>